import React from 'react';
import { Button, Grid } from '@mui/material';

function NumPad({ onKeyPress, array, width }) {
    const handleButtonClick = (key) => {
        onKeyPress(key);
      };
    return (
        <Grid container spacing={1}>
        {
        array.map((item, index) => (
            <Grid item xs={4} key={index}>
                <Button
                    color   = "secondary"
                    size    = "large"
                    variant = "contained"
                    style   = {{ fontSize: '33px', height:'60px', color:'#fff', backgroundColor:'#808080', padding:'3px', width: width || '95px' }}
                    onClick = {() => handleButtonClick(item)}
                    >
                    {item}
                </Button>
            </Grid>
        ))}
        </Grid>
    );
}

export default NumPad;